export const localized = (input, locale) => (
    typeof input === "string" ? input : input[locale]
);

export const normalized = (input) => input.replace(/\W/g, "_").toLowerCase();
